'use es6';

import tinymce from 'tinymce';
import Routes from 'ContentUtils/Routes';
const rgbaRegExp = /rgba\(\s*([0-9]{1,3}),\s*([0-9]{1,3}),\s*([0-9]{1,3}),\s*([0-9,.]+)\s*\)/;
export const hexAlphaToRgba = (hex, alpha) => {
  if (hex && alpha !== null && alpha < 100) {
    const color = new tinymce.util.Color(hex);
    const rgb = color.toRgb();
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha / 100})`;
  }
  return hex;
};
export const colorToHexAlpha = color => {
  let hex;
  let alpha = 100;
  if (rgbaRegExp.exec(color)) {
    const matches = rgbaRegExp.exec(color);
    const c = new tinymce.util.Color(`rgb(${matches[1]}, ${matches[2]}, ${matches[3]})`);
    hex = c.toHex();
    alpha = parseFloat(matches[4], 10) * 100;
  } else {
    const c = new tinymce.util.Color(color);
    hex = c.toHex();
  }
  return {
    hex,
    alpha
  };
};
export const getCurrentColor = (editor, format, computed = true, node = null) => {
  return editor.dom.getStyle(node || editor.selection.getStart(), format === 'forecolor' ? 'color' : 'backgroundColor', computed);
};
const nodeHasColorStyle = (editor, format, node, endNode) => {
  let hasColor = !!getCurrentColor(editor, format, false, node);
  let sawEndNode = node === endNode;
  let childResult;
  let i = 0;
  while (i < node.childNodes.length && !hasColor) {
    childResult = nodeHasColorStyle(editor, format, node.childNodes[i], endNode);
    hasColor = childResult.hasColor;
    sawEndNode = sawEndNode || childResult.sawEndNode;
    i++;
  }
  return {
    hasColor,
    sawEndNode
  };
};
export const selectionHasNodeWithColorStyle = (editor, format) => {
  if (!editor.selection) return false;
  const rng = editor.selection.getRng();
  if (rng.startContainer === rng.endContainer && rng.commonAncestorContainer.nodeName === '#text') {
    return !!getCurrentColor(editor, format, false, rng.commonAncestorContainer.parentNode);
  }
  let startNode = editor.selection.getStart();
  let hasColor = false;
  let result;
  while (!hasColor && startNode) {
    result = nodeHasColorStyle(editor, format, startNode, rng.endContainer);
    hasColor = result.hasColor;
    if (result.sawEndNode) break;
    startNode = startNode.nextSibling;
  }
  return hasColor;
};
export const getEditLink = editor => {
  return `${editor.settings.appUrl}${Routes.accountDefaults('branding/colors')}`;
};